/*
 * @Description: Description
 * @Author: Kun Yang
 * @Date: 2022-01-07 10:13:40
 * @LastEditors: Yongchao Wang
 * @LastEditTime: 2022-01-11 17:02:38
 */
import semver from 'semver/index';
import MeshManage from '../meshManage';
import VoxtorpDoor from '../specialHandler/voxtorpDoor';
import { 
// version2.0 无顶柜的时候默认抽油烟机距离顶柜的高度
FRAMECATEGORY, TYPECODE, } from './kitchenConfig';
// 适配版本的方法抽离
class RenderVersion {
    constructor(superThis) {
        this.superThis = superThis; // 实例传递需要使用的this
    }
    /**
   *
   * @param {string} oldVersion 第一个版本号
   * @param {string} newVersion 第二个版本号
   * @param {*} type 比较类型 lt lte gt gte等https://www.npmjs.com/package/semver
   * @description 判断两个版本号 默认小于
   * @author: Kun Yang
   * @returns 比较结果 true false
   */
    static checkOldRenderVersion(oldVersion, newVersion, type = 'lt') {
        const first = semver.valid(semver.coerce(oldVersion !== null && oldVersion !== void 0 ? oldVersion : '0'));
        const second = semver.valid(semver.coerce(newVersion));
        // type类型定义 https://www.npmjs.com/package/semver
        // return parseInt(firstVersion, 10) > parseInt(secondVersion, 10);
        return semver[type](first, second);
    }
    // 2.1版本以下高柜门板处理
    oldFunGroupMeshsHighFrameDoors(frameComponent, doors, location) {
        const frame = frameComponent.componentBasic;
        const { categoryId } = frameComponent;
        const parent = new MeshManage(this.superThis.scene.getMeshByName(frame.id));
        this.superThis.addMesh(parent.mesh);
        this.superThis.highFrameMesh = parent.mesh;
        let tempDoors = doors;
        let preHighDoorRotation = { x: 0, y: 0, z: 0 }; // 上一个高柜柜门的旋转角度，旋转后会上移，会影响下一个门板的排列
        let preMeshManage;
        // 如果是高柜/全隔板3开门，门板顺序倒一下，后端给的顺序不对
        if (frameComponent.categoryId === FRAMECATEGORY.CATEGORY_10) {
            tempDoors = tempDoors.reverse();
        }
        if (!(doors instanceof Array)) {
            tempDoors = [doors];
        }
        tempDoors = tempDoors.filter((e) => e.componentBasic.show && e.componentBasic.modelUrl);
        const children = tempDoors.map((e, index) => {
            // 因为上面倒序门板顺序
            let isbottom = false; // 是否是底部把手，高柜的上部柜子需要将把手装下面
            switch (categoryId) {
                case FRAMECATEGORY.CATEGORY_10:
                    // 高柜/全隔板3开门 index 0-》1 上柜-》下柜，决定了把手位置
                    if (index === 0) {
                        isbottom = true;
                    }
                    else {
                        isbottom = false;
                    }
                    break;
                case FRAMECATEGORY.CATEGORY_11:
                    // 高柜/烤箱柜 (一个洞) 三抽屉面板 -》上门板
                    if (index > 0) {
                        isbottom = true;
                    }
                    else {
                        isbottom = false;
                    }
                    break;
                default:
                    // 高柜/微波炉和烤箱柜(两个洞) 两抽屉面板 -》 上门板
                    if (index > 0) {
                        isbottom = true;
                    }
                    else {
                        isbottom = false;
                    }
                    break;
            }
            const child = new MeshManage(this.superThis.scene.getMeshByName(e.componentBasic.id));
            this.superThis.addMesh(child.mesh);
            parent.addChildModel(child);
            // 把手
            if (e.handle) {
                this.superThis.groupMeshsDoorHandle(frame, e, child, isbottom, true);
            }
            // 和后端align好，门板顺序是从左到右，抽屉是从下到上
            if (TYPECODE.DOORPLANK(e.componentBasic.typeCode)) {
                this.superThis.handleHighFrameDoorPlanks(parent, child, tempDoors, categoryId, index);
            }
            else if (TYPECODE.DRAWER(e.componentBasic.typeCode)) {
                // 如果不止一个抽屉,第二扇抽屉开始贴在第一抽屉板上面
                if (index > 1) {
                    const preChild = new MeshManage(this.superThis.scene.getMeshByName(doors[index - 1].componentBasic.id));
                    child.setModelPosition({
                        x: child.mesh.position.x,
                        y: preChild.mesh.position.y + preChild.getModelSize().y,
                        z: parent.getModelSize().z * 0.5 + child.getModelSize().z * 0.5,
                    });
                }
                else {
                    child.setModelPosition({
                        x: child.mesh.position.x,
                        y: child.mesh.position.y,
                        z: parent.getModelSize().z * 0.5 + child.getModelSize().z * 0.5,
                    });
                }
            }
            // template version2.0 如果是顶柜并且沃拓普 处理高柜的柜门  在添加到父级之前旋转
            // TODO: version 2.0 目前是看底柜的是不是沃拓普系列，因为暂时高柜不会和顶柜关联。
            if (location === 'bottom' && VoxtorpDoor.isVoxtorpDoor(this.superThis.templateJson.bottom)) {
                const voxtorpDoor = new VoxtorpDoor(frameComponent, e, child, this.superThis.scene);
                preHighDoorRotation = voxtorpDoor.rotateHighFrameDoor(index, preHighDoorRotation, preMeshManage);
                preMeshManage = child;
            }
            else if (location === 'top' && VoxtorpDoor.isVoxtorpDoor(this.superThis.templateJson.top)) {
                const voxtorpDoor = new VoxtorpDoor(frameComponent, e, child, this.superThis.scene);
                preHighDoorRotation = voxtorpDoor.rotateHighFrameDoor(index, preHighDoorRotation, preMeshManage);
                preMeshManage = child;
            }
            else {
                preMeshManage = null;
                preHighDoorRotation = { x: 0, y: 0, z: 0 };
            }
            return child;
        });
        return { parent, children };
    }
}
export default RenderVersion;
